// Vendors
import { atcb_action } from 'add-to-calendar-button';

const button = document.getElementById('add-to-calendar');

if (button) {
  const config = {
    name: button.dataset.name,
    description: button.dataset.description,
    startDate: button.dataset.startdate,
    startTime: button.dataset.starttime,
    endDate: button.dataset.enddate,
    endTime: button.dataset.endtime,
    location: button.dataset.location,
    timeZone: 'America/Chicago',
    options: [
      'Apple',
      'Google',
      'iCal',
      'Outlook.com',
      'MicrosoftTeams',
      'Microsoft365'
    ],
    listStyle: 'dropdown-static',
    buttonStyle: 'round',
    trigger: 'click',
    hideIconButton: true,
    lightMode: 'system',
    pastDateHandling: 'disable'
  };

  button.addEventListener('click', () => atcb_action(config, button));
}
